import { h } from "preact";
import { formatMoney } from "@helpers/currency";
import { CartData } from "@sections/cart";

interface MiniCartTotalsProps {
  cartData: CartData | null;
}

function MiniCartTotals({ cartData }: MiniCartTotalsProps) {
  const discount = cartData?.total_discount ?? 0;
  const total = cartData?.total_price ?? 0;
  const ogTotal = cartData?.original_total_price ?? 0;

  const showDiscount = discount > 0;

  const enableMinimumCartThreshold =
    window.themeVars.config.cart.enableMinimumCartThreshold;
  const minimumCartThreshold =
    window.themeVars.config.cart.minimumCartThreshold;

  let showFreeDeliveryMessage = true;

  if (enableMinimumCartThreshold && total < minimumCartThreshold) {
    showFreeDeliveryMessage = false;
  }

  const pfandChargeItem = cartData?.items?.find(
    (item: { title: string }) => item.title === "Pfand",
  );

  const pfandCharge = pfandChargeItem?.price;

  return (
    <div className="minicart__totals">
      <div className="minicart__totals-row">
        <p className="text-md-body">{window.themeVars.strings.cart.subtotal}</p>

        <p className="text-md-body">{formatMoney(ogTotal, true, true)}</p>
      </div>

      {pfandCharge && (
        <div className="minicart__totals-row">
          <p className="text-md-body">Pfand</p>

          <p className="text-md-body">{formatMoney(pfandCharge, true, true)}</p>
        </div>
      )}

      {showFreeDeliveryMessage && (
        <div className="minicart__totals-row">
          <p className="text-md-body">
            {window.themeVars.strings.cart.delivery}
          </p>

          <p className="text-md-body">{window.themeVars.strings.cart.free}</p>
        </div>
      )}

      {showDiscount && (
        <div className="minicart__totals-row">
          <p className="text-md-body">
            {window.themeVars.strings.cart.bestDiscountApplied}
          </p>

          <p className="text-md-body">- {formatMoney(discount, true, true)}</p>
        </div>
      )}

      <div className="minicart__totals-row">
        <p className="text-md-body--semi-bold">
          {window.themeVars.strings.cart.total}
        </p>

        <p className="text-md-body--semi-bold">
          {formatMoney(total, true, true)}
        </p>
      </div>
    </div>
  );
}

export default MiniCartTotals;
